import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_ZONES } from '../get-zones';
import { deleteZoneAPI } from './api';

export function useDeleteZone({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (zoneId) => deleteZoneAPI(zoneId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_ZONES, tenantId]);
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'success',
              description: 'deleteZoneSuccess',
            },
          });
        }, 100);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'deleteZoneError',
            },
          });
        }, 100);
      },
    },
  );

  return {
    deleteZone: mutate,
    deleteZoneAsync: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}
